/* Analytics scaffolding.
 * Scripts only load when (a) the corresponding ID is configured in .env and
 * (b) the visitor has accepted cookies. Add IDs to /app/frontend/.env:
 *   REACT_APP_GA4_ID=G-XXXXXXX
 *   REACT_APP_META_PIXEL_ID=XXXXXXXX
 *   REACT_APP_TIKTOK_PIXEL_ID=XXXXXXXX
 */

const IDS = {
  ga4: process.env.REACT_APP_GA4_ID,
  meta: process.env.REACT_APP_META_PIXEL_ID,
  tiktok: process.env.REACT_APP_TIKTOK_PIXEL_ID,
};

export const analyticsConfigured = () => Boolean(IDS.ga4 || IDS.meta || IDS.tiktok);

export const CONSENT_KEY = "di_cookie_consent";
export const getConsent = () => localStorage.getItem(CONSENT_KEY);

let loaded = false;

export function loadAnalytics() {
  if (loaded || !analyticsConfigured()) return;
  loaded = true;

  if (IDS.ga4) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${IDS.ga4}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", IDS.ga4);
  }

  if (IDS.meta) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", IDS.meta);
    window.fbq("track", "PageView");
  }

  if (IDS.tiktok) {
    /* eslint-disable */
    !(function (w, d, t) {
      w.TiktokAnalyticsObject = t; var ttq = (w[t] = w[t] || []);
      ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"];
      ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.load = function (e, n) {
        var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
        ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = i; ttq._t = ttq._t || {}; ttq._t[e] = +new Date();
        ttq._o = ttq._o || {}; ttq._o[e] = n || {};
        var o = document.createElement("script"); o.type = "text/javascript"; o.async = !0; o.src = i + "?sdkid=" + e + "&lib=" + t;
        var a = document.getElementsByTagName("script")[0]; a.parentNode.insertBefore(o, a);
      };
      ttq.load(IDS.tiktok); ttq.page();
    })(window, document, "ttq");
    /* eslint-enable */
  }
}

/** Fire a conversion event across all configured pixels (no-ops when unloaded). */
export function trackEvent(name, params = {}) {
  try {
    if (window.gtag) window.gtag("event", name, params);
    if (window.fbq) window.fbq("trackCustom", name, params);
    if (window.ttq && window.ttq.track) window.ttq.track(name, params);
  } catch (_) { /* analytics must never break the app */ }
}
